const initialState = {
    data: [],
  };
  
  const wspolnotaUReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_WSPOLNOTA':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default wspolnotaUReducer;